import script from "./StripePaymentForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./StripePaymentForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__